(() => {
const roots=new Set();
function init(root){
 if(root.dataset.aboutInitialized)return;root.dataset.aboutInitialized='true';roots.add(root);
 const config=JSON.parse(root.parentElement.querySelector('[data-about-config]').textContent);
 const controller=new AbortController();
 const RES=p=>{const m=p.match(/cans\/(.+)\.png/);return config.assets[m?.[1]]||p;};
 class AboutLogic{
  setState(update){const change=typeof update==='function'?update(this.state):update;if(change){this.state={...this.state,...change};this.render();}}
  get(path){return path.split('.').reduce((v,k)=>v?.[k],this.values);}
  render(){
   this.values=this.renderVals();
   root.querySelectorAll('[data-about-bind]').forEach(el=>Object.entries(JSON.parse(el.dataset.aboutBind)).forEach(([key,value])=>el.setAttribute(key,value.replace(/\[\[(.*?)\]\]/g,(_,path)=>this.get(path)??''))));
   root.querySelectorAll('[data-about-text]').forEach(el=>el.textContent=this.get(el.dataset.aboutText)??'');
   root.querySelectorAll('[data-about-if]').forEach(el=>el.hidden=!this.get(el.dataset.aboutIf));
   root.querySelectorAll('[data-about-action]').forEach(el=>{
    const key=el.dataset.aboutAction;
    if(key==='toggleMenu'){el.setAttribute('aria-expanded',String(this.state.menu));el.setAttribute('aria-controls','flippd-about-menu');}
    if(key==='heroFlip'||key==='wordFlip')el.setAttribute('aria-pressed',String(key==='heroFlip'?this.state.hero:this.state.word));
    if(/^(reel|team)\./.test(key))el.setAttribute('aria-pressed',String(!!this.state[key.split('.')[0]][key.split('.')[1]]));
    if(/^rules\./.test(key))el.setAttribute('aria-expanded',String(this.state.rule===Number(key.split('.')[1])));
    if(/^foot\./.test(key))el.setAttribute('aria-expanded',String(this.state.foot===Number(key.split('.')[1])));
   });
   const footLinks=[ [config.shop,config.shop+'?filter=bundles',config.root+'products/fizzy-aam-panna#flippd-pdp-buy'],[config.root+'#flippd-moments',config.root+'#flippd-moments',config.root+'#flippd-moments'],[config.account,config.shipping,config.returns,config.root+'pages/contact'] ];
   root.querySelectorAll('footer [data-about-text^="foot."]').forEach(el=>{if(el.parentElement.tagName==='A'){const parts=el.dataset.aboutText.split('.');el.parentElement.href=footLinks[parts[1]][parts[3]];}});
  }
 }
const C = { masala: '#EE2C24', orange: '#F36A22', lemon: '#F9E308', panna: '#70BF46', kaapi: '#C06D29', pink: '#E672E9' };
const REEL = [
  { y: '2022', t: 'The gap', b: 'Every healthy soda on the shelf tasted like a compromise. None of them tasted like home.', c: C.masala },
  { y: '2023', t: 'The first batch', b: 'Masala Cola, brewed in a home kitchen. Forty friends tried it. Thirty-one asked for more.', c: C.orange },
  { y: '2024', t: 'The flip can', b: 'We printed the ingredients upside down, so you read what is inside by flipping the can.', c: C.panna },
  { y: '2026', t: 'Today', b: 'Five flavours, every batch third-party tested, in fridges across India.', c: C.pink }
];
const STEPS = [
  { t: 'Source', b: 'Real fruit and whole spice from Indian farms.', c: C.panna },
  { t: 'Brew', b: 'Small batches, carbonated cold.', c: C.orange },
  { t: 'Test', b: 'Every batch lab-tested before it ships.', c: C.lemon },
  { t: 'Ship', b: 'Dispatched within 24 hours of packing.', c: C.pink }
];
const RULES = [
  { t: 'Taste decides', b: 'If it does not taste as good as the full-sugar version, it does not launch.' },
  { t: 'We taste every batch', b: 'Someone on the team drinks a can from every batch before it leaves.' },
  { t: 'Ingredients over margins', b: 'Real mango, real jeera, real coffee. We pay more so the can says less.' },
  { t: 'Know the source', b: 'We can name the farm behind every fruit and spice we use.' },
  { t: "Nothing we wouldn't serve", b: 'If we would not pour it for our own family, it is not for sale.' }
];
const TEAM = [
  { n: '[Name]', r: 'Founder', fav: 'Masala Cola', k: 'masala' },
  { n: '[Name]', r: 'Co-founder, flavour', fav: 'Aam Panna', k: 'panna' },
  { n: '[Name]', r: 'Head of quality', fav: 'Lemon Soda', k: 'lemon' },
  { n: '[Name]', r: 'Brand and design', fav: 'Sparkling Kaapi', k: 'kaapi' }
];
const FOOT = [
  { t: 'Shop', links: ['All flavours', 'Bundles', 'Subscribe'] },
  { t: 'Ways to enjoy', links: ['After meals', 'The 4pm dip', 'Post-run'] },
  { t: 'Support', links: ['Track order', 'Shipping', 'Returns', 'Contact'] }
];
class Component extends AboutLogic {
  state = { menu: false, hero: false, word: true, reel: {}, rule: 0, ruleAuto: true, team: {}, foot: -1, ctas: {}, cart: config.cart, bump: false, lift: -1 };
  timers = {};
  componentDidMount() {
    this.iv2 = setInterval(() => this.setState(s => ({ lift: (s.lift + 1) % 5 })), 900);
  }
  componentWillUnmount() { clearInterval(this.iv); clearInterval(this.iv2); Object.values(this.timers).forEach(clearTimeout); }
  cta(id, after) {
    const st = this.state.ctas[id], on = st === true;
    return { rot: on ? 'rotateX(180deg)' : 'rotateX(0deg)', opA: on ? 0 : 1, opB: on ? 1 : 0,
      tab: st ? 'rotateX(-58deg) translateY(-1px)' : 'rotateX(0deg)',
      click: () => {
        if (this.state.ctas[id]) return;
        this.setState(s => ({ ctas: { ...s.ctas, [id]: 'pull' } }));
        this.timers[id] = setTimeout(() => {
          this.setState(s => ({ ctas: { ...s.ctas, [id]: true } }));
          if (after) this.timers[id + 'n'] = setTimeout(after, 700);
          this.timers[id + 'b'] = setTimeout(() => this.setState(s => ({ ctas: { ...s.ctas, [id]: false } })), 1700);
        }, 380);
      } };
  }
  renderVals() {
    const s = this.state;
    const seen = Object.keys(s.reel).filter(k => s.reel[k]).length;
    return {
      menuOpen: s.menu, toggleMenu: () => this.setState(st => ({ menu: !st.menu })),
      cart: s.cart, cartBump: s.bump ? 'scale(1.3)' : 'scale(1)',
      heroRot: s.hero ? 'rotate(180deg)' : 'rotate(0deg)', heroA: s.hero ? 0 : 1, heroB: s.hero ? 1 : 0,
      heroHint: s.hero ? 'Flipped ✓ · tap to flip back' : 'Tap the can to flip it',
      heroFlip: () => { clearTimeout(this.timers.h2); this.setState(st => ({ hero: !st.hero })); },
      wordRot: s.word ? 'rotate(180deg)' : 'rotate(0deg)', wordFlip: () => this.setState(st => ({ word: !st.word })),
      reel: REEL.map((r, i) => ({ ...r, n: '0' + (i + 1), rot: s.reel[i] ? 'rotateX(180deg)' : 'rotateX(0deg)', bar: s.reel[i] ? r.c : 'rgba(255,255,255,.25)',
        flip: () => this.setState(st => ({ reel: { ...st.reel, [i]: !st.reel[i] } })) })),
      steps: STEPS.map((x, i) => ({ ...x, n: '0' + (i + 1) })),
      rules: RULES.map((r, i) => { const on = s.rule === i;
        return { ...r, n: '0' + (i + 1), open: on, tc: on ? '#F9E308' : '#FFFFFF', bg: on ? '#F9E308' : 'transparent', fg: on ? '#0B0B0B' : '#FFFFFF',
          rot: on ? 'rotate(180deg)' : 'rotate(0deg)', click: () => this.setState({ rule: i, ruleAuto: false }) }; }),
      team: TEAM.map((m, i) => ({ ...m, n:config.names[i] || m.n, slot: 'about-team-' + (i + 1), can: RES(`cans/${m.k}-logo.png`), c: m.k === 'kaapi' ? '#E3A56E' : C[m.k],
        rot: s.team[i] ? 'rotateX(180deg)' : 'rotateX(0deg)', flip: () => this.setState(st => ({ team: { ...st.team, [i]: !st.team[i] } })) })),
      lineup: ['masala', 'orange', 'lemon', 'panna', 'kaapi'].map((k, i) => ({ src: RES(`cans/${k}-${i % 2 ? 'art' : 'logo'}.png`),
        t: `translateY(${s.lift === i ? -16 : 0}px) rotate(${[-8, -4, 0, 4, 8][i]}deg)` })),
      shopCta: this.cta('shop', () => { window.location.href = config.shop; }),
      foot: FOOT.map((x, i) => ({ ...x, open: s.foot === i, rot: s.foot === i ? 'rotate(45deg)' : 'rotate(0deg)', toggle: () => this.setState(st => ({ foot: st.foot === i ? -1 : i })) }))
    };
  }
}
 const app=new Component();app.render();app.componentDidMount();
 const scrollWords=[...root.querySelectorAll('.about-scroll-word')];
 const ruleButtons=[...root.querySelectorAll('[data-about-action^="rules."]')];
 let lastScroll=window.scrollY, scrollFrame=0;
 function updateScroll(){
  scrollFrame=0;
  const y=window.scrollY, moved=Math.abs(y-lastScroll)>=2;
  if(moved){
   const down=y>lastScroll;
   scrollWords.forEach(word=>{const box=word.getBoundingClientRect();if(box.top<window.innerHeight-90&&box.bottom>76)word.classList.toggle('is-inverted',down);});
   lastScroll=y;
  }
  const target=window.innerHeight*.45;
  const candidates=ruleButtons.map((button,index)=>{const box=button.firstElementChild.getBoundingClientRect();return {index,box,distance:Math.abs((box.top+box.bottom)/2-target)};}).filter(item=>item.box.bottom>90&&item.box.top<window.innerHeight-50);
  if(candidates.length){
   const nearest=candidates.reduce((a,b)=>a.distance<b.distance?a:b);
   const current=candidates.find(item=>item.index===app.state.rule);
   if(nearest.index!==app.state.rule&&(!current||nearest.distance+24<current.distance))app.setState({rule:nearest.index});
  }
 }
 function queueScroll(){if(!scrollFrame)scrollFrame=requestAnimationFrame(updateScroll);}
 window.addEventListener('scroll',queueScroll,{passive:true,signal:controller.signal});
 window.addEventListener('resize',queueScroll,{signal:controller.signal});
 queueScroll();
 const nav=root.querySelector('.about-condition nav');nav.id='flippd-about-menu';
 root.querySelectorAll('[data-about-action]').forEach(el=>{if(el.tagName!=='BUTTON'){el.setAttribute('role','button');el.tabIndex=0;el.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();el.click();}},{signal:controller.signal});}});
 root.addEventListener('click',event=>{const el=event.target.closest('[data-about-action]');if(el){const fn=app.get(el.dataset.aboutAction);if(typeof fn==='function')fn();}},{signal:controller.signal});
 nav.addEventListener('click',()=>app.setState({menu:false}),{signal:controller.signal});
 document.addEventListener('click',event=>{
   const button=root.querySelector('[data-about-action="toggleMenu"]');
   if(app.state.menu&&!nav.contains(event.target)&&!button.contains(event.target))app.setState({menu:false});
 },{signal:controller.signal});
 document.addEventListener('flippd:cart-updated',event=>app.setState({cart:event.detail.item_count}),{signal:controller.signal});
 const film=root.parentElement.querySelector('.about-film-dialog');
 root.querySelector('[data-about-film]').addEventListener('click',()=>{if(!config.film){const notice=root.parentElement.querySelector('.about-notice');notice.textContent='Our film is coming soon.';notice.classList.add('visible');clearTimeout(app.timers.notice);app.timers.notice=setTimeout(()=>notice.classList.remove('visible'),3000);return;}film.querySelector('video').src=config.film;film.showModal();film.querySelector('video').play().catch(()=>{});},{signal:controller.signal});
 film.querySelector('button').addEventListener('click',()=>film.close());film.addEventListener('close',()=>film.querySelector('video').pause());
 root.cleanupAbout=()=>{controller.abort();cancelAnimationFrame(scrollFrame);app.componentWillUnmount();};
}
function initialize(){roots.forEach(root=>{if(!root.isConnected){root.cleanupAbout();roots.delete(root);}});document.querySelectorAll('[data-flippd-about]').forEach(init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
document.addEventListener('shopify:section:load',initialize);
new MutationObserver(records=>{if(records.some(record=>[...record.addedNodes,...record.removedNodes].some(node=>node.nodeType===1&&(node.matches?.('[data-flippd-about]')||node.querySelector?.('[data-flippd-about]')))))initialize();}).observe(document.body,{childList:true,subtree:true});
})();
